import React, { useEffect, useMemo, useRef, useState } from "react";
import styled from "styled-components";
import Breadcrumbs from "../based/Breadcrumbs";
import Common from "../based/Common";
import { NOTIFY, PLATFORM, SHIPPING_SERVICES_CODE } from "../based/Constants";
import { Notify } from "../based/Notify";
import BaseServices from "../based/services/BaseServices";
import CommonServices from "../based/services/CommonServices";
import OrderServices from "../based/services/OrderServices";
import Ranus from "./assets/Ranus.svg";
import SPX from "./assets/SPX.png";
import ShippingBarcodeModal from "./ShippingBarcodeModal";
import Loading from "../based/Loading";
import CameraSection from "./CameraSection";
const DirectPrint = "DIRECT_PRINT";

function PackingManage(props) {
    const [currentPacking, setCurrentPacking] = useState({}); //thông tin barcode
    const [barcode, setBarcode] = useState("");
    const [lstOrder, setLstOrder] = useState([]); //danh sách đơn hàng
    const [shippingServices, setShippingServices] = useState([]); //đơn vị vận chuyển
    const inputRef = useRef(null);
    const [barcodeModal, setBarcodeModal] = useState(false); //modal in nhãn ship
    const [loading, setLoading] = useState(false); //loading
    const cameraRef = useRef(null);

    useEffect(() => {
        _getShippingServices();
    }, []);

    const handleFocus = () => {
        inputRef.current?.focus();
    };

    async function _handleScanBarcode(barcode) {
        const [err, dt] = await BaseServices.Get(`/api/PetPressed/get-pet-by-code/${barcode}`);
        if (!err && dt) {
            setCurrentPacking(dt);

            //lấy thông tin đơn hàng
            _getOrderData(dt.orderId, dt.operatorOrderId);

            //reset barcode
            setBarcode("");

            //kiểm tra nếu là đơn hàng shopee, và chưa có tracking number thì gọi api chuẩn bị nhãn ship
            if (dt.platform == PLATFORM.Shopee && (dt.shippingOrderNumber == "" || dt.shippingOrderNumber == null)) {
                const [err, data] = await OrderServices.PrePrintShippingLabel(dt.orderId);
            }
        } else {
            setCurrentPacking({});
        }
    }

    async function _getShippingServices() {
        let [err, data] = await CommonServices.GetShippingServices();
        if (!err && data && data.length > 0) {
            //kiểm tra đã có item được checked hay chưa
            let anyChecked = data.every((item) => item.isChecked);
            if (!anyChecked) {
                var spx = data.find((x) => x.code == SHIPPING_SERVICES_CODE.SHOPEEXPRESS);
                if (spx) spx.isChecked = true;
                else data[0].isChecked = true;
            }

            setShippingServices(data);
        } else {
            setShippingServices([]);
        }
    }

    async function _getOrderData(orderId, tagId = 0) {
        var [err, data] = await BaseServices.Get(`/api/operator/get-order-packaging-model/${orderId}`);
        if (!err && data) {
            let orders = lstOrder ? [...lstOrder] : [];
            let order = orders.find((item) => item.id == data.id);

            //nếu chưa có thì thêm mới
            orders.map((item) => (item.isChecked = false));
            if (!order) {
                data.isChecked = true;
                orders.push(data);
            } else {
                order.isChecked = true;
            }

            //lấy ra đơn hàng đang được checked
            let checkOrder = orders.find((item) => item.isChecked);
            if (checkOrder && checkOrder.listOrderProductModel && checkOrder.listOrderProductModel.length > 0) {
                for (var orderProduct of checkOrder.listOrderProductModel) {
                    if (orderProduct.listOrderTag && orderProduct.listOrderTag.length > 0) {
                        for (var tag of orderProduct.listOrderTag) {
                            if (tag.tagId == tagId) {
                                tag.isChecked = true;
                            }
                        }
                    }
                }
            }
            setLstOrder(orders);
        } else {
            Notify(NOTIFY.WARNING, NOTIFY.WARNING, "Không tìm thấy thông tin đơn hàng");
        }
    }

    async function _checkScanBarcode(barcode) {
        let ss = [...shippingServices];
        let item = ss.find((x) => x.packageBarcode == barcode);
        //nếu có item trùng với barcode, thì
        if (item) {
            item.isChecked = true;
            setShippingServices(ss);
            setBarcode("");

            //lấy ra đơn hàng đang được checked
            const orderId = checkedOrder.id;
            const platform = checkedOrder.platform;
            const shippingCode = item ? item.code : "";
            const shippingCompanyId = item ? item.id : 0;

            //kiểm tra tất cả các tag được checked hay chưa
            let allChecked = true;
            if (checkedOrder.listOrderProductModel && checkedOrder.listOrderProductModel.length > 0) {
                for (var orderProduct of checkedOrder.listOrderProductModel) {
                    if (orderProduct.listOrderTag && orderProduct.listOrderTag.length > 0) {
                        for (var tag of orderProduct.listOrderTag) {
                            if (!tag.isChecked) {
                                allChecked = false;
                                break;
                            }
                        }
                    }
                }
                if (!allChecked) {
                    Notify(NOTIFY.WARNING, NOTIFY.WARNING, "Vui lòng chọn tất cả các tag để in nhãn ship");
                    return;
                }
            }

            if (platform == PLATFORM.Internal) {
                handleInteralPrint(orderId, shippingCode, shippingCompanyId);
            } else {
                //nếu đơn External (Lazada, Shopee)
                handleExternalPrint(orderId, platform);
            }
            return true;
        }
        return false;
    }

    async function _handleDirectPrint() {
        if (!checkedOrder) return;
        //nếu đơn Internal (Ranus)
        const orderId = checkedOrder.id;
        const platform = checkedOrder.platform;
        const shippingService = shippingServices ? shippingServices.find((x) => x.isChecked) : null;
        const shippingCode = shippingService ? shippingService.code : "";
        const shippingCompanyId = shippingService ? shippingService.id : 0;

        //kiểm tra tất cả các tag được checked hay chưa
        let allChecked = true;
        if (checkedOrder.listOrderProductModel && checkedOrder.listOrderProductModel.length > 0) {
            for (var orderProduct of checkedOrder.listOrderProductModel) {
                if (orderProduct.listOrderTag && orderProduct.listOrderTag.length > 0) {
                    for (var tag of orderProduct.listOrderTag) {
                        if (!tag.isChecked) {
                            allChecked = false;
                            break;
                        }
                    }
                }
            }
            if (!allChecked) {
                Notify(NOTIFY.WARNING, NOTIFY.WARNING, "Vui lòng chọn tất cả các tag để in nhãn ship");
                return;
            }
        }

        if (platform == PLATFORM.Internal) {
            handleInteralPrint(orderId, shippingCode, shippingCompanyId);
        } else {
            //nếu đơn External (Lazada, Shopee)
            handleExternalPrint(orderId, platform);
        }
    }

    const handleInteralPrint = async (orderId, shippingCode, shippingCompanyId) => {
        switch (shippingCode) {
            case SHIPPING_SERVICES_CODE.RANUS:
                //call api in nhãn ship
                await APIServices.HandlePrintRanus(orderId, shippingCompanyId);
                break;
            case SHIPPING_SERVICES_CODE.VNPOST:
                //call api in nhãn ship
                await APIServices.HandlePrintVNPost(orderId, shippingCompanyId);
                break;
            case SHIPPING_SERVICES_CODE.SHOPEEXPRESS:
                //call api in nhãn ship
                await APIServices.HandlePrintSPX(orderId, shippingCompanyId);
                break;
            default:
                break;
        }

        //chuyển sang trạng thái sẵn sàng giao
        await APIServices.HandleReadyToShip(orderId);

        //bật label in nhãn ship
        window.open(`/shipping-label/${orderId}`, "_blank");
    };

    const handlePrintPDF = (fileLink) => {
        //kiểm tra iframe
        let iframe = document.getElementById("print_pdf");
        if (!iframe) {
            iframe = document.createElement("iframe");
            iframe.id = "print_pdf";
            iframe.name = "print_pdf";
            iframe.style.display = "none";
        }

        iframe.src = fileLink;
        iframe.onload = () => {
            iframe.contentWindow.addEventListener("afterprint", (evt) => {
                console.log("printed");
                document.body.removeChild(iframe);
            });

            window.frames["print_pdf"].focus();
            window.frames["print_pdf"].print();
        };
        document.body.appendChild(iframe);
    };

    const handleExternalPrint = async (orderId, platform) => {
        setLoading(true);
        //chuyển sang trạng thái sẵn sàng giao
        if (platform == PLATFORM.Lazada || platform == PLATFORM.Tiktok) await APIServices.HandleReadyToShip(orderId);

        //call api lấy nhãn
        let [error, data] = await OrderServices.PrintShippingLabel(orderId, 0);
        if (!error && data) {
            switch (platform) {
                case PLATFORM.Lazada:
                    handlePrintPDF(data.url);
                    break;
                case PLATFORM.Shopee:
                    if (data.url) {
                        let arr = data.url.split(",");
                        if (arr && arr.length > 0) {
                            arr.map((url) => {
                                handlePrintPDF(url);
                            });
                        }
                    }
                    break;
                case PLATFORM.Tiktok:
                    handlePrintPDF(data.url);
                    break;
                default:
                    break;
            }
        } else {
            Notify(NOTIFY.ERROR, "Lỗi", error.message ? error.message : "Có lỗi xảy ra trong quá trình in nhãn ship");
        }
        setLoading(false);
    };

    const APIServices = {
        HandlePrintSPX: async (orderId, shippingCompanyId) => {
            const [error, data] = await OrderServices.PrintShippingLabel(orderId, shippingCompanyId);
            if (!error && data) {
                Notify(NOTIFY.SUCCESS, "Thành công", "In nhãn ship thành công");
            } else {
                Notify(NOTIFY.ERROR, "Lỗi", error.message ? error.message : "Có lỗi xảy ra trong quá trình in nhãn ship");
            }
        },
        HandlePrintVNPost: async (orderId, shippingCompanyId) => {
            const [error, data] = await OrderServices.PrintShippingLabel(orderId, shippingCompanyId);
            if (!error && data) {
                Notify(NOTIFY.SUCCESS, "Thành công", "In nhãn ship thành công");
            } else {
                Notify(NOTIFY.ERROR, "Lỗi", error.message ? error.message : "Có lỗi xảy ra trong quá trình in nhãn ship");
            }
        },
        HandlePrintRanus: async (orderId, shippingCompanyId) => {
            const [error, data] = await OrderServices.PrintShippingLabelRanus(orderId, shippingCompanyId);
            if (!error && data) {
                Notify(NOTIFY.SUCCESS, "Thành công", "In nhãn ship thành công");
            } else {
                Notify(NOTIFY.ERROR, "Lỗi", error.message ? error.message : "Có lỗi xảy ra trong quá trình in nhãn ship");
            }
        },
        HandleReadyToShip: async (orderId) => {
            const [err, data] = await OrderServices.SetStatusToReadyToShip(orderId);
        },
        HandleShopeePreShippingLabel: async (orderId) => {
            const [err, data] = await OrderServices.PrePrintShippingLabel(orderId);
        },
    };

    const checkedOrder = useMemo(() => {
        let checked = lstOrder ? lstOrder.find((item) => item.isChecked) : false;
        if (checked) {
            return checked;
        }
        return null;
    }, [lstOrder]);

    if (!currentPacking) return <div className="no-data">Không tìm thấy thông tin sản phẩm</div>;
    return (
        <React.Fragment>
            <Breadcrumbs currentPage="Quản lý đóng gói" />
            <Loading show={loading} msg="Đang xử lý..." />
            <Wrapper onClick={handleFocus} onMouseDown={handleFocus} onMouseMove={handleFocus}>
                <section className="packing-left">
                    <section className="info-packing">
                        <section className="search-barcode">
                            <div className="search-area">
                                <input
                                    type="text"
                                    placeholder="Mã sản xuất"
                                    value={barcode}
                                    onChange={(e) => {
                                        setBarcode(e.target.value);
                                        if (e.target.value && e.target.value.length == 6) _handleScanBarcode(e.target.value);
                                        if (e.target.value == DirectPrint) {
                                            _handleDirectPrint();
                                            setBarcode("");
                                        } else {
                                            if (checkedOrder && checkedOrder.platform == PLATFORM.Internal) _checkScanBarcode(e.target.value);
                                        }
                                    }}
                                    onKeyDown={(e) => {
                                        //nêu nhấn enter thì gọi hàm _handleScanBarcode
                                        if (e.keyCode === 13) {
                                            _handleScanBarcode(barcode);
                                        }
                                    }}
                                    ref={inputRef}
                                />
                                <button
                                    className="btn btn-enter"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        _handleScanBarcode(barcode);
                                    }}
                                >
                                    Nhập
                                </button>
                            </div>
                        </section>
                        <section className="barcode-info">
                            <div className="grid-container">
                                <div className="grid-name">
                                    <span>{currentPacking.productName}</span>
                                </div>
                                <div className="grid-size">
                                    <span className="size-left">Size</span>
                                    <span className="size-right">{currentPacking.size}</span>
                                </div>
                                <div className="grid-tag">
                                    <span className="tag-left">Tag ID</span>
                                    <span className="tag-right">{currentPacking.operatorOrderId}</span>
                                </div>
                                <div className="grid-color">
                                    <div
                                        style={{
                                            background: `#${currentPacking.colorCode}`,
                                            color: `${currentPacking.colorCode == "#f7f7f7" ? "#000" : "#fff"}`,
                                        }}
                                    >
                                        {currentPacking.colorName}
                                    </div>
                                </div>
                            </div>
                            <div className="list-thumbnail">
                                {currentPacking.barcodes &&
                                    currentPacking.barcodes.length > 0 &&
                                    currentPacking.barcodes.map((item, index) => {
                                        return (
                                            <div className="thumbnail-item" key={index}>
                                                <img src={item.productImageUrl} alt="thumbnail" />
                                                <div className="thumbnail-name">
                                                    <span>
                                                        {item.artworkType == 1 ? "Mặt trước:" : "Mặt sau:"} <b>{item.barcode}</b>
                                                    </span>
                                                </div>
                                            </div>
                                        );
                                    })}
                            </div>
                        </section>
                        {currentPacking.partnerLogoModel && (
                            <section className="brand-info">
                                <div className="list-brand-item">
                                    {currentPacking.partnerLogoModel.thumbnail && (
                                        <div className="brand-item">
                                            <img src={currentPacking.partnerLogoModel.thumbnail} alt="" />
                                        </div>
                                    )}
                                    {currentPacking.partnerLogoModel.logo && (
                                        <div className="brand-item">
                                            <img src={currentPacking.partnerLogoModel.logo} alt="" />
                                        </div>
                                    )}
                                </div>
                            </section>
                        )}
                    </section>

                    {/* section camera */}
                    {checkedOrder && checkedOrder.id > 0 && <CameraSection orderId={checkedOrder.id} cameraRef={cameraRef} />}
                </section>
                <section className="packing-right">
                    <ul className="nav nav-tabs tabs-bordered">
                        {lstOrder &&
                            lstOrder.length > 0 &&
                            lstOrder.map((item, index) => {
                                return (
                                    <li className={`nav-item ${item.isChecked ? "btn-light" : "active"}`} key={index}>
                                        <a
                                            className="nav-link"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                let orders = lstOrder.map((order) => {
                                                    order.isChecked = false;
                                                    return order;
                                                });
                                                orders[index].isChecked = true;
                                                setLstOrder(orders);
                                            }}
                                        >
                                            Đơn hàng {item.id}
                                        </a>
                                    </li>
                                );
                            })}
                    </ul>
                    {checkedOrder && (
                        <div className="package_detail_header">
                            <div className="header-left">
                                <div className="grid-header">
                                    <div className="grid-item grid-order-id">
                                        <div className="grid-light">
                                            <span>Mã đơn Ranus</span>
                                        </div>
                                        <div
                                            className="a-item cursor-pointer"
                                            onClick={(e) => {
                                                window.open(`/order-detail/${checkedOrder.id}`, "_blank", "noopener,noreferrer");
                                            }}
                                        >
                                            <span>
                                                {checkedOrder.id} <i className="fa fa-external-link-square" />
                                            </span>
                                        </div>
                                    </div>
                                    <div className="grid-item grid-order-number">
                                        <div className="grid-light">
                                            <span>Mã đơn hàng</span>
                                        </div>
                                        <div className="a-bold">
                                            <span>{checkedOrder.platformOrderNumber}</span>
                                        </div>
                                    </div>
                                    <div className="grid-item grid-order-customer-detail">
                                        <div className="customer-name">{checkedOrder.userName}</div>
                                        <div className="customer-address">
                                            <span>{checkedOrder.phoneNumber}</span>
                                            <span>{checkedOrder.fullAddress}</span>
                                        </div>
                                    </div>
                                    <div className="grid-item grid-order-payment">
                                        <div className="payment-method">{checkedOrder.paymentMethodName}</div>
                                        <div className="payment-money">{Common.formatCurrency(checkedOrder.remainPrice)}</div>
                                        {checkedOrder.isPackage && (
                                            <button className="payment-package">
                                                <span>Đóng gói hộp</span>
                                            </button>
                                        )}
                                    </div>
                                    <div className="grid-item grid-order-created-date">
                                        <div className="grid-light">
                                            <span>Ngày đặt hàng</span>
                                        </div>
                                        <div className="a-bold">
                                            <span>{Common.formatDate(new Date(checkedOrder.createdDate))}</span>
                                        </div>
                                    </div>
                                    <div className="grid-item grid-order-batch">
                                        <div className="grid-light">
                                            <span>Batch SX</span>
                                        </div>
                                        <div className="a-bold">
                                            {checkedOrder.listBatch &&
                                                checkedOrder.listBatch.length > 0 &&
                                                checkedOrder.listBatch.map((item, index) => {
                                                    return (
                                                        <span key={index} className="active">
                                                            {item}
                                                        </span>
                                                    );
                                                })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="header-right">
                                <div className="shipping-company">
                                    <label htmlFor="">Đơn vị vận chuyển</label>
                                    <a
                                        className="edit-barcode"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setBarcodeModal(true);
                                        }}
                                    >
                                        Sửa Barcode
                                    </a>
                                    <div className="list-radio">
                                        {shippingServices &&
                                            checkedOrder.platform == PLATFORM.Internal &&
                                            shippingServices.length > 0 &&
                                            shippingServices.map((item, index) => {
                                                let lg = item.logo;
                                                if (item.code == SHIPPING_SERVICES_CODE.RANUS) lg = Ranus;
                                                else if (item.code == SHIPPING_SERVICES_CODE.SHOPEEXPRESS) lg = SPX;
                                                return (
                                                    <div
                                                        className="radio-item cursor-pointer"
                                                        key={index}
                                                        onClick={(e) => {
                                                            let services = shippingServices.map((service) => {
                                                                service.isChecked = false;
                                                                return service;
                                                            });
                                                            services[index].isChecked = true;
                                                            setShippingServices(services);
                                                        }}
                                                    >
                                                        <input type="radio" name="" id="" checked={item.isChecked} />
                                                        <div className="icon">
                                                            <img src={lg} alt="" />
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                    </div>
                                </div>
                                <div className="print-label">
                                    <button
                                        className="btn btn-custom"
                                        onClick={(e) => {
                                            _handleDirectPrint();
                                        }}
                                    >
                                        In nhãn ship
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="package_detail_body">
                        <h6>
                            Danh sách sản phẩm có trong đơn
                            {/* <span className="total-product">26 sản phẩm</span> */}
                        </h6>
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <td className="center" width="160px">
                                        Hình ảnh
                                    </td>
                                    <td className="center">Tag ID</td>
                                    <td className="center">Dòng sản phẩm</td>
                                    <td className="center">Màu</td>
                                    <td className="center">Size</td>
                                    <td className="center">SL</td>
                                </tr>
                            </thead>
                            <tbody>
                                {checkedOrder &&
                                    checkedOrder.listOrderProductModel &&
                                    checkedOrder.listOrderProductModel.length > 0 &&
                                    checkedOrder.listOrderProductModel.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <td className="center">
                                                    <div className="lst-img">
                                                        {item.listImage &&
                                                            item.listImage.length > 0 &&
                                                            item.listImage.map((img, index) => {
                                                                return <img src={img.productImageUrl} alt="" key={index} />;
                                                            })}
                                                    </div>
                                                </td>
                                                <td className="vertical-align-middle">
                                                    <div className="list-tag-id">
                                                        {item.listOrderTag &&
                                                            item.listOrderTag.length > 0 &&
                                                            item.listOrderTag.map((barcode, i) => {
                                                                return (
                                                                    <span
                                                                        key={i}
                                                                        className={barcode.isChecked ? "active cursor-pointer" : "cursor-pointer"}
                                                                        onClick={(e) => {
                                                                            let orders = [...lstOrder];
                                                                            let order = orders.find((x) => x.id == checkedOrder.id);
                                                                            if (order) {
                                                                                let tags = order.listOrderProductModel[index].listOrderTag;
                                                                                let bc = tags[i];
                                                                                bc.isChecked = !bc.isChecked;
                                                                                setLstOrder(orders);
                                                                            }
                                                                        }}
                                                                    >
                                                                        {barcode.tagId}
                                                                    </span>
                                                                );
                                                            })}
                                                    </div>
                                                </td>
                                                <td className="center">{item.appProductVariantName}</td>
                                                <td className="center">{item.colorName}</td>
                                                <td className="center">{item.size}</td>
                                                <td className="center">{item.quantity}</td>
                                            </tr>
                                        );
                                    })}
                            </tbody>
                        </table>
                    </div>
                </section>
            </Wrapper>
            <ShippingBarcodeModal
                onClose={() => {
                    setBarcodeModal(false);
                    _getShippingServices();
                }}
                show={barcodeModal}
            />
        </React.Fragment>
    );
}

export default PackingManage;

const Wrapper = styled.div`
    display: flex;
    height: calc(100vh - 110px);

    .thumbnail-name {
        color: black;
    }

    .radio-item .icon img {
        height: 24px;
        object-fit: contain;
    }

    .grid-tag {
        padding: 5px 10px;
    }

    .list-thumbnail {
        display: flex;
        padding: 16px;
    }

    .thumbnail-item {
        width: 50%;
        height: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .thumbnail-item img {
        width: 100%;
        height: auto;
        object-fit: contain;
    }

    .grid-color {
        border: 1px solid #d9d9d9;
        background: #fff;
        height: 44px;
        flex: 1;
        padding: 5px 10px;
    }

    .grid-color div {
        border: 1px solid #d9d9d9;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        text-overflow: ellipsis;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .list-brand-item {
        display: flex;
    }

    .brand-item {
        width: 100px;
        height: 100px;
    }

    .brand-item img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    section.brand-info {
        padding: 12px 17px;
    }

    section.gift-item {
        border: 1px solid #f1f1f1;
        background: #fff;
        margin: 24px 0;
        padding: 12px 14px;
    }

    section.gift-item label {
        color: #444;
        font-family: Roboto;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 125% */
        margin: 0;
    }

    .list-label {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-top: 12px;
    }

    .label-item {
        width: 70px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 5px 10px 5px 0;
    }

    .label-item img {
        width: 100%;
        height: auto;
        object-fit: contain;
    }

    .label-name {
        color: #444;
        font-family: Roboto;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    section.packing-right {
        margin-left: 40px;
    }

    .package_detail_header {
        background: white;
        display: flex;
    }

    .header-left {
        padding: 16px;
        flex: 1;
        border: 1px solid #f1f1f1;
        background: #fff;
    }

    .grid-header {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-auto-rows: auto;
    }

    .grid-item {
        border: 1px solid #d9d9d9;
        background: #fff;
        padding: 10px 12px;
    }

    .grid-order-customer-detail {
        grid-row: span 2;
    }

    .grid-order-payment {
        grid-row: span 2;
        display: flex;
        flex-direction: column;
        padding: 0;
    }

    .grid-light {
        color: #817979;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .a-item {
        color: #13aaff;
        font-family: Roboto;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin-top: 6px;
    }

    .a-bold {
        color: #444;
        font-family: Roboto;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        margin-top: 6px;
    }

    .customer-name {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    .customer-address {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-top: 6px;
    }

    .customer-address span {
        display: block;
        margin: 4px 0;
    }

    .payment-method {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        padding: 10px 12px 0 12px;
    }

    .payment-money {
        color: #444;
        font-family: Roboto;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        margin: 6px 0;
        padding: 0 12px;
    }

    button.payment-package {
        width: 100%;
        margin-top: auto;
        border: 1px solid #d9d9d9;
        background: #1f2022;
        color: #fff;
        font-family: Roboto;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        height: 46px;
    }

    .header-right {
        width: 355px;
        border: 1px solid #f1f1f1;
        background: #fff;
        padding: 16px;
    }

    .shipping-company {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }

    .shipping-company label {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 142.857% */
        margin: 0;
    }

    .list-radio {
        width: 100%;
    }

    a.edit-barcode {
        color: #64c5b1 !important;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px; /* 142.857% */
        margin-left: auto;
    }

    .list-radio {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        align-items: center;
    }

    .radio-item {
        display: flex;
        align-items: center;
        height: 24px;
    }

    .radio-item .icon {
        display: flex;
    }

    .radio-item input[type="radio"] {
        margin-right: 6px;
    }

    .print-label {
        margin-top: 24px;
        width: 100%;
    }

    .print-label button.btn.btn-custom {
        width: 100%;
        font-size: 16px;
        height: 46px;
    }

    .package_detail_body {
        border: 1px solid #f1f1f1;
        background: #fff;
        padding: 16px 16px;
    }

    .package_detail_body h6 {
        overflow: hidden;
        color: #444;
        text-overflow: ellipsis;
        font-family: Roboto;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .package_detail_body h6 span.total-product {
        overflow: hidden;
        color: #444;
        text-overflow: ellipsis;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-left: 8px;
    }

    .table thead {
        border: 1px solid #d9d9d9;
        background: #e4e4e4;
    }

    tr td img {
        width: 70px;
        height: 70px;
        object-fit: contain;
    }

    .lst-img {
        display: flex;
    }

    .list-tag-id span {
        overflow: hidden;
        color: #444;
        text-overflow: ellipsis;
        font-family: Roboto;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        background: #f1f1f1;
        padding: 2px 4px;
        margin: 4px 7px;
    }

    .list-tag-id span.active {
        background: #28b259;
        overflow: hidden;
        color: #fff;
        text-overflow: ellipsis;
        font-family: Roboto;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    section.packing-left {
        width: 400px;
    }

    section.packing-right {
        flex: 1;
    }

    section.info-packing {
        background: white;
    }

    section.search-barcode {
        padding: 18px;
        border: 1px solid #f1f1f1;
        background: #fff;
    }

    .search-area {
        display: flex;
    }

    .search-area input[type="text"] {
        flex: 1;
        padding: 9px 13px;
        border: 1px solid #d9d9d9;
        background: #fff;
    }

    button.btn.btn-enter {
        border: 1px solid #d9d9d9;
        background: #64c5b1;
        color: #fff;
        text-align: center;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 142.857% */
    }

    section.barcode-info {
        padding: 18px;
        border: 1px solid #f1f1f1;
        background: #fff;
    }

    .grid-container {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }

    .grid-name {
        border: 1px solid #d9d9d9;
        background: #fff;
        height: 44px;
        display: flex;
        align-items: center;
        padding: 11px 12px;
        width: 65%;
    }

    .grid-size {
        flex: 1;
        border: 1px solid #d9d9d9;
        background: #fff;
        display: flex;
        align-items: center;
        padding: 11px 12px;
        height: 44px;
    }

    .grid-name span {
        overflow: hidden;
        color: #444;
        text-overflow: ellipsis;
        font-family: Roboto;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
    }

    .grid-size {
    }

    span.size-right {
        overflow: hidden;
        color: #444;
        text-align: right;
        text-overflow: ellipsis;
        font-family: Roboto;
        font-size: 34px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin-left: auto;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
    }

    span.size-left {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .grid-tag {
        height: 44px;
        border: 1px solid #d9d9d9;
        background: #fff;
        display: flex;
        align-items: center;
        width: 70%;
    }

    span.tag-left {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    span.tag-right {
        color: #444;
        font-family: Roboto;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        margin-left: 4px;
    }
`;
